import { useEffect, useState } from 'react';
import useMedia from 'use-media';
import breakpoints from '~/globals/breakpoints';

/**
 * AK: post-migration would like to change how responsiveness is handled in
 * this new ssr next.js world. See @arty/fresnel
 */

/**
 * DEPRECATED
 * -- Use Fresnel's <Media /> component instead for most cases --
 * DEPRECATED
 * @param query
 * @param defaultValue
 * @returns [result, ready]
 */
export default function useMediaReady(query: string, defaultValue: any = null) {
  const [ready, setReady] = useState(false);
  const queryResult = useMedia(query, defaultValue);
  const isMobileTest = useMedia(breakpoints.isWithinMobile, true);
  const isDesktopTest = useMedia(breakpoints.desktop, true);

  useEffect(() => {
    if (isDesktopTest !== true || isMobileTest !== true) {
      setReady(true);
    }
  }, [isDesktopTest, isMobileTest]);

  return [queryResult, ready];
}
